/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MediaCrop = {
    properties: {
        cropAspectRatio: {
            type: 'number',
        },
        cropX: {
            type: 'number',
        },
        cropY: {
            type: 'number',
        },
        cropScale: {
            type: 'number',
        },
    },
} as const;
